export const NavSub = {
  transclude: {
    left: '?navLeft',
    right: '?navRight',
  },

  bindings: {
    active: '@',
  },

  template: `
    <nav class="navbar navbar-sub bg-gray-100 border border-y">
      <div class="container">
        <div class="d-flex justify-content-between w-100">
          <div ng-transclude="left"></div>
          <div ng-transclude="right"></div>
        </div>
      </div>
    </nav>`,
};



// WEBPACK FOOTER //
// ./src/components/Nav/NavSub.js